import { gql } from '@apollo/client';

export const DELETE_PERMISSION_PACKAGE = gql`
  mutation DeletePermissionPackage($input: DeleteByIdInput!) {
    deletePermissionPackage(input: $input) {
      success
      message
      messageCode
    }
  }
`;

export interface DeletePermissionPackageInput {
  id: number;
}

export interface DeletePermissionPackageResponse {
  deletePermissionPackage: {
    success: boolean;
    message: string;
    messageCode?: string | null;
  };
}

export interface DeletePermissionPackageVariables {
  input: DeletePermissionPackageInput;
}

